import * as types from './types';
export default {
  [types.SET_CART_SUCCESS](state, payload) {
    state.success = payload;
  },
  [types.SET_CART_SUCCESS_SERVER](state, payload) {
    state.successServer = payload;
  },
  [types.SET_CART](state, payload) {
    state.items = payload;
  },
  [types.SET_CART_QTY](state, payload) {
    state.total = payload;
  },
  [types.SET_CART_STATE](state, payload) {
    state.cartState = payload;
  },
  [types.SET_CART_SELLER_ID](state, sellerId) {
    state.sellerId = sellerId;
  }
};